import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/ReceiveReport/ARReportReceiveAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ARReportReceiveActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/ReceiveReport/ARReportReceive")
	}

	render() {
		return (
			<Activity 
				name="ARReportReceive"
				RenderedComponent={this.RenderedComponent}
				context="ARReportReceive"
				action="ARReportReceive"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ARReportReceiveActivity)
